import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../auth/auth.service';
import { BanksService } from '../bank-management/banks.service';
import { ManageTicketServiceService } from '../manage-tickets/manage-ticket-service.service';
import { DmtService } from '../services/dmt.service';
import { MD5UtilService } from '../services/MD5Util.service';
import { RechargeService } from '../services/recharge.service';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CountdownComponent } from 'ngx-countdown';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-move-to-distributor',
  templateUrl: './move-to-distributor.component.html',
  styleUrls: ['./move-to-distributor.component.scss']
})
export class MoveToDistributorComponent implements OnInit {
  entities:any = []
  form: FormGroup;
  private formSubmitAttempt: boolean;
  private formOtpSubmitAttempt: boolean;
  retailor_phoneNumber: any;
  isValidOtp: boolean = false;
  isSubmit: boolean = false;
  walletAmount: Object;
  userCurrenPosition: any;
  uacid: string;
  otpform: FormGroup;
  status = 'ready';
  @ViewChild('countdown') counter: CountdownComponent;
  isResendEnable: boolean = false;
  isChecked: boolean=false;
  isCheckedl2: boolean=false;
  isCheckedl3: boolean=false;
  distributorType: any;
  refNumber:any
  constructor(
    private dmtservice: DmtService,
    private authService: AuthService,
    public service: ManageTicketServiceService,
    private fb: FormBuilder,
    private rechargeSer: RechargeService,
    private toastr: ToastrService,
    private bankService: BanksService,
    private router: Router,
    private ngxService: NgxUiLoaderService,

    config: NgbModalConfig, private modalService: NgbModal

  ) {
    config.backdrop = 'static';
    config.keyboard = false;
    this.retailor_phoneNumber = localStorage.getItem('retailor_phoneNumber')
    this.form = this.fb.group({
      amount: ['', Validators.required],
      comments: ['', Validators.required],
      otpOn:['MOBILE',Validators.required]

    });
    this.otpform = this.fb.group({
      otp: ['', Validators.required],
    });

    // this.uacid=localStorage.getItem('uacid');
    this.userDistributorTreeApi();
  }
  isFieldInvalid(field: string) {
    return (
      (!this.form.get(field).valid && this.form.get(field).touched) ||
      (this.form.get(field).untouched && this.formSubmitAttempt)
    );
  }
  isOtpFieldInvalid(field: string) {
    return (
      (!this.otpform.get(field).valid && this.otpform.get(field).touched) ||
      (this.otpform.get(field).untouched && this.formOtpSubmitAttempt)
    );
  }
  
  close(content) {
    this.modalService.dismissAll(content);
  }
  
  userDistributorTreeApi(){
    this.ngxService.start();

    this.bankService.userDistributorTree().subscribe((res: any) => {
      this.entities.push(res.object);
      console.log(this.entities);
      this.ngxService.stop();

    },err=>{
      this.ngxService.stop();

    })
  }
  selectDis(details,type){
    console.log(type);
    this.distributorType=type;
    if(type=="L1"){
      this.isChecked=true;
      this.isCheckedl2=false;
      this.isCheckedl3=false;

    }else if(type=="L2"){
      this.isChecked=false;
      this.isCheckedl2=true;
      this.isCheckedl3=false;

    }else{
    this.isChecked=false;
    this.isCheckedl2=false;
    this.isCheckedl3=true;


    }
  }

  selectDis2(details,type){
    console.log(type);
    if(type=="l1"){
      this.isChecked=false;
      // this.isCheckedl2=false;
      // this.isCheckedl3=false;

    }else if(type=="l2"){
      // this.isChecked=false;
      this.isCheckedl2=false;
      // this.isCheckedl3=false;

    }else{
    // this.isChecked=false;
    // this.isCheckedl2=false;
    this.isCheckedl3=false;


    }
  }
  ngOnDestroy(): void {
  }
  changeBank() {
    this.router.navigate(['/bank-management']);
  }
  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  ngOnInit() {
    this.fetchWalletBalance();
    this.getLocationDetails();
  }
  getLocationDetails() {
    if (navigator.geolocation) {
      let _this = this
      navigator.geolocation.getCurrentPosition(function (postion) {
        _this.userCurrenPosition = postion;
        console.log(_this.userCurrenPosition);
      });
    }
  }
  handleEvent(event) {
    console.log(event.action);
    if (event.action == 'finished') {
      this.isResendEnable = true;
      console.log(this.isResendEnable);
    }
  }
  sendOTP(content) {
    this.formSubmitAttempt = true;
    if (this.form.invalid) {
      return;
    }
    if(this.distributorType=='' || this.distributorType==null){
      this.toastr.error('Select one Distributor to process further');
      
    }else{
      this.ngxService.start();
      // this.dmtservice.sendOtp(this.retailor_phoneNumber,'move_to_distributor').subscribe((res: any) => {
      //   console.log(res);
      //   this.ngxService.stop();
  
      //   if (res.status_code == 200) {
      //     this.modalService.open(content);
  
      //   }
      // }, errData => {
      //   console.log(errData);
      //   this.ngxService.stop();
  
      // })
      this.dmtservice.sendOtp2(this.form.value.otpOn).subscribe((res: any) => {
        console.log(res);
        this.ngxService.stop();
  
        if (res.status_code == 1) {
          this.modalService.open(content);
          this.refNumber=res.object.refNumber
  
        }
      }, errData => {
        console.log(errData);
        this.ngxService.stop();
  
      })
    }
  

  }
  resendOTP() {
    this.ngxService.start();

    // this.dmtservice.sendOtp(this.retailor_phoneNumber,'move_to_distributor').subscribe((res: any) => {
    //   console.log(res);
    //   this.ngxService.stop();

    //   if (res.status_code == 200) {
    //     this.isResendEnable = false;

    //   } else {
    //     this.toastr.error(res.error.message);

    //   }
    // }, errData => {
    //   console.log(errData);
    //   this.ngxService.stop();

    // })

    this.dmtservice.sendOtp2(this.form.value.otpOn).subscribe((res: any) => {
      console.log(res);
      this.ngxService.stop();

      if (res.status_code == 1) {
        this.isResendEnable = false;
        this.refNumber=res.object.refNumber

      } else {
        this.toastr.error(res.error.message);

      }
    }, errData => {
      console.log(errData);
      this.ngxService.stop();

    })
  }
  validateOTP(form, content) {
    console.log(form);
    this.ngxService.start();

    this.formOtpSubmitAttempt = true;
    if (this.otpform.invalid) {
      this.otpform.markAllAsTouched()
      this.ngxService.stop();

      return;
    }
    // this.dmtservice.validateOtp(reqParams).subscribe((otpvalRes: any) => {
    //   console.log('otpvalRes', otpvalRes);
    //   this.ngxService.stop();

    //   if (otpvalRes.status_code == 200) {
    //     this.isValidOtp = true;
    //     this.toastr.success(otpvalRes.msg);
    //     this.close(content);
    //     this.onSubmit();
    //   } else {
    //     this.toastr.error(otpvalRes.error.message);


    //   }
    // }, errData => {
    //   console.log(errData);
    //   this.ngxService.stop();

    //   this.toastr.error(errData.error.message);

    // })
  else{
    if(this.distributorType=='' || this.distributorType==null){
      this.toastr.error('Select one Distributor to process further');
      
    }else{
     this.ngxService.start();
      // this.rechargeSer.movetoDistributor(this.form.value, this.distributorType).subscribe((res: any) => {
      //   console.log('res', res);
      // this.ngxService.stop();

      //   if (res.status_code == 1) {
      //     this.toastr.success(res.message);
      //     this.form.controls['amount'].reset();
      //     this.form.controls['comments'].reset();
      //     this.isValidOtp = false;
      //     this.isSubmit = false;
      //    this.router.navigate(['/dashboard']);

  
      //   } else {
      //     this.toastr.error(res.error.message);
  
      //   }
      // }, err => {
      // this.ngxService.stop();

      //   // this.toastr.error(err.error.message);
      // })
      this.rechargeSer.movetoDistributor2(this.form.value, this.distributorType,this.otpform.value.otp,this.refNumber).subscribe((res: any) => {
        console.log('res', res);
      this.ngxService.stop();

        if (res.status_code == 1) {
           this.close(content);
          this.toastr.success(res.message);
          this.form.controls['amount'].reset();
          this.form.controls['comments'].reset();
          this.isValidOtp = false;
          this.isSubmit = false;
         this.router.navigate(['/dashboard']);

  
        } else {
          this.toastr.error(res.error.message);
  
        }
      }, err => {
      this.ngxService.stop();

        // this.toastr.error(err.error.message);
      })
    }
  }
  }
  fetchWalletBalance() {
    this.authService.getRetailerWalletBalance().subscribe((res: any) => {
      this.walletAmount = res.balance;
    });
  }
  
  onSubmit() {

   
  
  }

}

